<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.member_sos_click_log") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-md-3.col-2.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-secret
                  DebounceInput(autofocus type="text" v-model="searchOperatorID" :placeholder="$t('ui.operator_id')" @enter="getLogList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="searchOperatorID.length > 0")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchMemberID" :placeholder="$t('ui.member_id')" @enter="getLogList(true)" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getLogList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="12%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th(width="15%" @click="sortOrder('client_ip')")
                          span(:title="$t('ui.ip')") {{ $t('ui.ip') }}
                          .float-right
                            i(:class="changeSortKey('client_ip')")
                        th.text-right(width="15%" @click="sortOrder('action_date')")
                          span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                          .float-right
                            i(:class="changeSortKey('action_date')")
                    tbody.clusterize-content
                      tr(v-if="logList.length == 0")
                        td(:colspan="4").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in logList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.client_ip") {{ item.client_ip }}
                        td.text-right
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcel from "@/library/jsonToExcelFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    loading2: false,
    logList: [],
    currentPage: 1,
    totalRow: 0,
    searchOperatorID: "",
    searchMemberID: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "action_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.isOperator) {
      this.searchOperatorID = this.accountID
      this.getLogList(true);
    }
  },
  methods: {
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getListing() {
      this.getLogList(true);
    },
    getData(currentValue) {
      this.getLogList(true);
    },
    getLogList: function(isSearch) {
      let url = config.memberSosClickLogUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.searchOperatorID,
        member_id: this.searchMemberID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.searchMemberID.trim() != '')
        json.search_id = this.searchMemberID;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.logList = response.data.dt;
                this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>